<div class="driver-information flex-column d-flex gap-4 " *transloco="let t; prefix: 'driverInformation'">
  <div class="row  driver-information__header align-items-center">
    <div class="col-lg-7 col-md-12 align-self-center">
      <h2 class="h3 m-0">{{ t('title') }}</h2>
    </div>
    <div class="col-lg-5">
      <div class="d-flex gap-2 justify-content-end align-content-center">
        <div class="flex-grow-1">
          <app-driver-search-filter [disabled]="!hasDrivers()"></app-driver-search-filter>
        </div>
        <div class="d-flex justify-content-end add-driver-button">
          <button class="btn btn-primary btn--add-drivers" (click)="openAddDriverModal()">{{ t('addDriver') }}</button>
        </div>
      </div>
    </div>
  </div>
  @if (!listLoaded || !detailsLoaded) {
    <div class="spinner-overlay">
      <div class="d-flex align-items-center justify-content-center spinner-border"></div>
    </div>
  }
  @if (isSearching && !isDriverFound && listLoaded && detailsLoaded) {
    <div class="d-flex driver-not-found-container">
      <div class="no-drivers-icon">
        <img src="assets\icons\exclamation_circle.svg" alt="no-drivers-image">
      </div>
      <p class="driver-not-found-message">{{ t('driverNotFound') }}</p>
    </div>
  }
  @if (!isSearching && !isDriverFound && listLoaded && detailsLoaded) {
    <div class="d-flex no-drivers-container">
      <h2 class="no-drivers-title">{{ t('noDrivers') }}</h2>
      <div class="no-drivers-icon">
        <img src="assets\icons\exclamation_circle.svg" alt="no-drivers-image">
      </div>
      <p class="no-drivers-message">{{ t('noDriversMessage') }} <br> {{ t('noDriversAction') }}</p>
      <button class="btn btn-primary btn-add-driver" (click)="openAddDriverModal()">{{ t('addDriver') }}</button>
    </div>
  }
  <div class="d-flex information-details"
    [ngClass]="{'no-drivers': !isDriverFound, 'd-none': !listLoaded || !detailsLoaded}">
    <div class="col-auto information-details__list" [ngClass]="{'no-drivers': !isDriverFound}">
      <app-driver-information-list (loaded)="listLoaded = $event" [hasDrivers]="hasDrivers"></app-driver-information-list>
    </div>
    <div class="flex-grow-1 information-details__content" [ngClass]="{'no-drivers': !isDriverFound}">
      <app-driver-information-details (loaded)="detailsLoaded = $event"></app-driver-information-details>
    </div>
  </div>
</div>